import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

import Panel from 'react-bootstrap/lib/Panel';
import UnstyledPanelGroup from 'react-bootstrap/lib/PanelGroup';

import StyledPanelBody from './StyledPanelBody';
import StyledPanelTitle from './StyledPanelTitle';

import './accordionStyles.css';

const PanelGroup = styled(UnstyledPanelGroup)`
    width: 100%;
    ${media.desktop`
        padding: 0 ${ds.get('metrics.s')};
    `};
`;

PanelGroup.Panel = Panel;
PanelGroup.Heading = Panel.Heading;

PanelGroup.Title = StyledPanelTitle;
PanelGroup.Body = StyledPanelBody;

export default PanelGroup;



// WEBPACK FOOTER //
// ./src/blocks/PanelGroup/index.jsx